import axios from 'axios';

export const accountsHttpClient = axios.create({
	baseURL: process.env.REACT_APP_ACCOUNTS_BASE_URL ?? '',
	headers: {
		'Content-Type': 'application/json',
		'X-Esmt-Application': process.env.REACT_APP_XESMT_APPLICATION
	}
});
